import React from "react";
import logo from '../assets/images/logo.png';

const Logo = () => {
  return (
    <div
        className="w-32 h-24 bg-cover bg-center"      
      style={{ backgroundImage: `url(${logo})` }}
    >           
    </div>
  );
};

export default Logo;
